export default [
  {
    path: '/likes',
    alias: '/',
    name: 'likesIndex',
    meta: { layout: 'default', auth: true },
    component: require('@/views/likes/LikesIndex').default,
  },
  {
    path: '/interests/:slug',
    name: 'interestPage',
    meta: { layout: 'default', auth: true },
    component: require('@/views/interests/InterestShow').default,
  },
  {
    path: '/people',
    name: 'peopleIndex',
    meta: { layout: 'default', auth: true },
    component: require('@/views/people/PeopleIndex').default,
  },
  {
    path: '/people/:slug',
    name: 'peopleShow',
    meta: { layout: 'default', auth: true },
    component: require('@/views/people/PeopleShow').default,
  },
  {
    path: '/visitors',
    name: 'visitorsIndex',
    meta: { layout: 'default', auth: true },
    component: require('@/views/visits/VisitorsIndex').default,
  },
  {
    path: '/visited',
    name: 'visitedIndex',
    meta: { layout: 'default', auth: true },
    component: require('@/views/visits/VisitedIndex').default,
  },
  {
    path: '/blocks',
    name: 'blocks',
    meta: { layout: 'default', auth: true },
    component: require('@/views/blocks/BlockView').default,
  },
  {
    path: '/settings',
    name: 'userSettings',
    meta: { layout: 'default', auth: true },
    component: require('@/views/users/UserSettings').default,
  },
  {
    path: '/privacy',
    name: 'privacy',
    meta: { layout: 'info' },
    component: require('@/views/info/Privacy').default,
  },
  {
    path: '/about',
    name: 'about',
    meta: { layout: 'info' },
    component: require('@/views/info/About').default,
  },
  {
    path: '/tos',
    name: 'tos',
    meta: { layout: 'info' },
    component: require('@/views/info/Tos').default,
  },
]
